import {
  ICoreErrorResponse,
  ICoreResponse,
} from "@/core/interfaces/coreResponse.interface";
import { StatusCodes } from "http-status-codes";
import { ActionContext, ActionTree } from "vuex";
import { ISectorState } from "@/core/interfaces/sectorState.interface";
import SectorService from "@/modules/Sector/services/sector.service";
import { SECTOR_ANALYTICS_EVENTS } from "../constants/analyticsEvents";
import notificationService from "@/core/services/notification.service";
import { NOTIFICATION_TYPES } from "@/core/enums/NOTIFICATION_TYPES";
import analyticServices from "@/analytic.service";
import { NOTIFICATION_MESSAGES } from "@/core/constants/notificationMessages";
import { SectorProductivityParamsRequestModel } from "../models/FetchSectorProductivityParams.request";
import { StoreState } from "@/store/type";

const actions: ActionTree<ISectorState, StoreState> = {
  async fetchSectors(context: ActionContext<ISectorState, StoreState>) {
    try {
      const sectorService = new SectorService();
      const response: ICoreResponse = await sectorService.getAll();
      context.commit("setSectorLoading", true);
      if (response.success && response.status === StatusCodes.OK) {
        context.commit("saveSectors", response.data);
      } else {
        throw response;
      }
    } catch (error: unknown) {
      // Handle error silently
    } finally {
      context.commit("setSectorLoading", false);
    }
  },

  // *********** Get Sector Stats ***********
  async getSectorStats(
    context: ActionContext<ISectorState, StoreState>,
    sectorId,
  ) {
    let response: ICoreResponse = {
      success: false,
    };
    try {
      context.commit("setSectorStatsLoading", true);
      context.commit("setSectorStats", null);
      context.commit("setSectorProductivity", null);
      const sectorService = new SectorService();
      response = await sectorService.getSectorStats(sectorId);
      if (response.success && response.status === StatusCodes.OK) {
        context.commit("setSectorStats", response.data?.data);
        analyticServices.logActionEvent(
          SECTOR_ANALYTICS_EVENTS.SECTOR_STATS_FETCHED,
          {
            sectorId,
          },
        );
        notificationService.type = NOTIFICATION_TYPES.SUCCESS;
        notificationService.description =
          "Sector statistics fetched successfully";
      } else {
        throw response;
      }
    } catch (error: unknown) {
      notificationService.type = NOTIFICATION_TYPES.ERROR;
      notificationService.description =
        exception.message || exception.error || NOTIFICATION_MESSAGES.DEFAULT;
    } finally {
      context.commit("setSectorStatsLoading", false);
    }
    notificationService.triggerNotification();
  },

  // *********** Get Sector Productivity ***********
  async getSectorProductivity(
    context: ActionContext<ISectorState, StoreState>,
    {
      sectorId,
      payload,
    }: { payload: SectorProductivityParamsRequestModel; sectorId: string },
  ) {
    let response: ICoreResponse = {
      success: false,
    };
    try {
      context.commit("setSectorProductivityLoading", true);
      context.commit("setSectorProductivity", null);
      const sectorService = new SectorService();
      response = await sectorService.getSectorProductivity(sectorId, payload);
      if (response.success && response.status === StatusCodes.OK) {
        context.commit("setSectorProductivity", response.data?.data);
        analyticServices.logActionEvent(
          SECTOR_ANALYTICS_EVENTS.SECTOR_PRODUCTIVIY_FETCHED,
          {
            sectorId,
            ...payload,
          },
        );
        notificationService.type = NOTIFICATION_TYPES.SUCCESS;
        notificationService.description =
          "Sector productivity fetched successfully";
      } else {
        throw response;
      }
    } catch (error: unknown) {
      notificationService.type = NOTIFICATION_TYPES.ERROR;
      notificationService.description =
        exception.message || exception.error || NOTIFICATION_MESSAGES.DEFAULT;
    } finally {
      context.commit("setSectorProductivityLoading", false);
    }
    notificationService.triggerNotification();
  },
};

export default actions;
